export const secondsToTime = (secs,) => {
	const hours = Math.floor(secs / (60 * 60),)

	const divisorForMinutes = secs % (60 * 60)
	const minutes = Math.ceil(divisorForMinutes / 60,)

	return `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}`
}
